import { AddAssignment } from "./AddAssignment";
import { AssignmentList } from "./AssignmentList";
import Button from "./Button";

export const Body = () => {
  return (
    <section className="body">
        <p></p>
        <AssignmentList/>
    </section>
  );
};
